export const CREATE_PERSONAL_TRUSTPASS = "CREATE_PERSONAL_TRUSTPASS";
export const RECEIVE_PERSONAL_TRUSTPASS = "RECEIVE_PERSONAL_TRUSTPASS";
export const PERSONAL_TRUSTPASS_FACEBOOK_AUTH = "PERSONAL_TRUSTPASS_FACEBOOK_AUTH";

export const UPDATE_PERSONAL_TRUSTPASS_INFO = "UPDATE_PERSONAL_TRUSTPASS_INFO";
export const UPLOAD_PERSONAL_TRUSTPASS_PRIMARY_ID = "UPLOAD_PERSONAL_TRUSTPASS_PRIMARY_ID";
export const UPLOAD_PERSONAL_TRUSTPASS_SECONDARY_ID = "UPLOAD_PERSONAL_TRUSTPASS_SECONDARY_ID";



// WEBPACK FOOTER //
// ./src/features/trustpass/personalTrustpassActionTypes.js